<template>
  <div class="sinotico-container" :class="{ 'vertical': vertical }"
    aria-live="off">
    <div v-if="titulo" aria-hidden="true">
        <span class="sinotico-titulo">{{ titulo }}</span>
    </div>
    <!-- Linha principal de progresso -->
    <div class="linha-progresso"
      role="list"
      aria-label="Pontos da rota">
      <!-- Ponto inicial -->
      <div class="ponto ponto-inicial" :style="getPontoStyle(0)"
        :data-ponto-id="pontoInicial?.id_cerca"
        @click="onParadaClick(pontoInicial)"
        @keydown.enter="onParadaClick(pontoInicial)"
        @focus="onParadaFocus(pontoInicial)"
        tabindex="0"
        role="listitem"
        :aria-label="`${isParadaMaisProxima(pontoInicial) ? 'Parada mais próxima. ' : ''}${isPontoSelecionado(pontoInicial) ? 'Você está em: ' : ''}Ponto inicial: ${pontoInicial?.nome_cerca || 'Início'}`"
        style="cursor: pointer;">
        <div class="ponto-circulo inicial" :class="{ 'ativa': isParadaAtiva(pontoInicial), 'selecionada': isPontoSelecionado(pontoInicial), 'selecionada-ida': isPontoSelecionado(pontoInicial) && sentidoId === 1, 'selecionada-volta': isPontoSelecionado(pontoInicial) && sentidoId === 2 }" :style="getParadaStyle(pontoInicial)"></div>
        <div class="ponto-label">
            <span :class="getLabelClass(pontoInicial)">{{ pontoInicial?.nome_cerca }}</span>
        </div>
      </div>

        <!-- Veículos -->
        <div 
        v-for="veiculo in veiculosSelecionados"
        :key="veiculo.id_veiculo"
        class="veiculo"
        :style="getVeiculoStyle(veiculo)"
        @focus="onVeiculoFocus(veiculo)"
        @keydown.enter="onVeiculoEnter(veiculo)"
        tabindex="0"
        role="listitem"
        :aria-label="`Veículo ${veiculo.cod_veiculo || 'Veículo'}`"
        >
        <div class="veiculo-icone">
            <div class="veiculo-info">
                <span class="veiculo-nome">{{ veiculo.cod_veiculo || 'Veículo' }}</span>
                <span class="veiculo-status" v-if="!vertical">{{ formatTimestamp(veiculo.dt_gps) }}</span>
            </div>
            <div class="veiculo-gota" :style="getVeiculoGotaStyle(veiculo)">
            <i class="mdi mdi-bus" :style="getVeiculoGotaIconStyle()"></i>
            </div>
        </div>
        </div>

      <!-- Pontos de parada intermediárias -->
      <div 
        v-for="(parada, index) in paradasFiltered" 
        :key="parada.id_cerca || index"
        class="ponto ponto-parada"
        :class="{ 'visitada': isParadaVisitada(index) }"
        :style="getPontoStyle(index + 1)"
        :data-ponto-id="parada.id_cerca"
        @click="onParadaClick(parada)"
        @keydown.enter="onParadaClick(parada)"
        @focus="onParadaFocus(parada)"
        tabindex="0"
        role="listitem"
        :aria-label="`${isParadaMaisProxima(parada) ? 'Parada mais próxima. ' : ''}${isPontoSelecionado(parada) ? 'Você está em: ' : ''}Parada: ${parada.nome_cerca || 'Parada ' + (index + 1)}`"
        style="cursor: pointer;"
      >
        <div 
          class="ponto-circulo parada" 
          :class="{ 'ativa': isParadaAtiva(parada), 'selecionada': isPontoSelecionado(parada), 'selecionada-ida': isPontoSelecionado(parada) && sentidoId === 1, 'selecionada-volta': isPontoSelecionado(parada) && sentidoId === 2 }"
          :style="getParadaStyle(parada)"
        >
        </div>
        <div class="ponto-label">
          <span :class="getLabelClass(parada)">{{ parada.nome_cerca || `Parada ${index + 1}` }}</span>
          <span v-if="parada.horario_passagem && parada.horario_passagem !== 'undefined'" class="label-hora">{{ parada.horario_passagem }}</span>
        </div>
      </div>

      <!-- Ponto final -->
      <div class="ponto ponto-final" :style="getPontoStyle(paradasFiltered.length + 1)"
        :data-ponto-id="pontoFinal?.id_cerca"
        @click="onParadaClick(pontoFinal)"
        @keydown.enter="onParadaClick(pontoFinal)"
        @focus="onParadaFocus(pontoFinal)"
        tabindex="0"
        role="listitem"
        :aria-label="`${isParadaMaisProxima(pontoFinal) ? 'Parada mais próxima. ' : ''}${isPontoSelecionado(pontoFinal) ? 'Você está em: ' : ''}Ponto final: ${pontoFinal?.nome_cerca || 'Final'}`"
        style="cursor: pointer;">
        <div class="ponto-circulo final" :class="{ 'ativa': isParadaAtiva(pontoFinal), 'selecionada': isPontoSelecionado(pontoFinal), 'selecionada-ida': isPontoSelecionado(pontoFinal) && sentidoId === 1, 'selecionada-volta': isPontoSelecionado(pontoFinal) && sentidoId === 2 }" :style="getParadaStyle(pontoFinal)"></div>
        <div class="ponto-label">
          <span :class="getLabelClass(pontoFinal)">{{ pontoFinal?.nome_cerca }}</span>
          <span class="label-hora" v-if="getPassagemVeiculo(pontoFinal)">
            {{ getPassagemVeiculo(pontoFinal) }}
          </span>
        </div>
      </div>

      <!-- Segmentos da linha conectando os pontos -->
      <div 
        v-for="(segmento, index) in segmentosLinha"
        :key="`segmento-${index}`"
        class="segmento-linha"
        :class="{ 'percorrido': segmento.percorrido }"
        :style="getSegmentoStyle(index, segmento.percorrido)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SinoticoParadas',
    props: {
        paradas: {
            type: Array,
            required: true
        },
        pontoInicial: {
            type: Object,
            required: false,
            default: null
        },
        pontoFinal: {
            type: Object,
            required: false,
            default: null
        },
        veiculos: {
            type: Array,
            required: true
        },
        vertical: {
            type: Boolean,
            required: false,
            default: false
        },
        titulo: {
            type: String,
            required: false,
            default: null
        },
        corDestaque: {
            type: String,
            required: false,
            default: null
        },
        pontoSelecionado: {
            type: Object,
            required: false,
            default: null
        },
        pontoMaisProximo: {
            type: Object,
            required: false,
            default: null
        },
        /** 1 = ida (verde), 2 = volta (laranja) */
        sentidoId: {
            type: Number,
            required: false,
            default: 1
        }
    },
    data() {
        return {
            marginVertical: 1,
            marginHorizontal: 10,
            spacingVertical: 120,
            spacingHorizontal: 80,
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    watch: {
        pontoSelecionado: {
            handler(newPonto) {
                if (newPonto && this.vertical) {
                    this.$nextTick(() => {
                        this.centralizarScrollNoPonto(newPonto);
                    });
                }
            },
            immediate: true
        }
    },
    computed: {
        paradasFiltered() {
          
          return this.paradas;
        },
        paradaAtualIndex() {
            const maxOrdemParada = Math.max(...this.veiculosSelecionados.map((v) => {
              if (v.ordem_parada_efetiva != null) return Number(v.ordem_parada_efetiva);
              if (v.ordem_parada_atual) return v.ordem_parada_atual;
              if (v.ordem_parada_ultima != null) return Number(v.ordem_parada_ultima);
              if (v.ordem_cerca_proxima_parada != null && Number(v.ordem_cerca_proxima_parada) > 1) {
                return Number(v.ordem_cerca_proxima_parada) - 1;
              }
              if (v.ordem_parada) return v.ordem_parada + 1;
              return -1;
            }));
            return this.paradas.findIndex(p => p.ordem_parada === maxOrdemParada);
        },
        veiculosSelecionados() {
            return this.veiculos;
        },
        totalPontos() {
            return this.paradasFiltered.length + 2;
        },
        segmentosLinha() {
            // Cria segmentos entre cada par de pontos
            const segmentos = [];
            for (let i = 0; i < this.totalPontos - 1; i++) {
                segmentos.push({
                    inicio: i,
                    fim: i + 1,
                    percorrido: this.paradaAtualIndex === -1 ? false : i <= this.paradaAtualIndex
                });
            }
            return segmentos;
        },
        primaryColor() {
            if (this.corDestaque) {
                return this.corDestaque;
            } else {
                return this.$vuetify.theme.currentTheme.primary;
            }
        },
        spacingFactor() {
          if (this.vertical) {
            return Math.abs(window.innerHeight - 100) / 40;
          } else {
            return Math.abs(window.innerWidth - 100) / 50;
          }
        }
    },
    methods: {
        /** Verifica se o ponto é o selecionado (compara id_cerca de forma segura para número/string) */
        isPontoSelecionado(ponto) {
            if (!this.pontoSelecionado || !ponto) return false;
            const idA = this.pontoSelecionado.id_cerca;
            const idB = ponto.id_cerca;
            if (idA == null || idB == null) return false;
            return String(idA) === String(idB);
        },
        formatTimestamp(dtGps) {
            // If dt_gps is already in HH:MM:SS format, return it as is
            if (!dtGps) return '';
            if (typeof dtGps === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(dtGps)) {
                return dtGps;
            }
            // If it's an ISO string or other format, parse and format it
            try {
                const date = new Date(dtGps);
                return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            } catch (e) {
                return dtGps;
            }
        },
        getPontoStyle(index) {
            const total = this.totalPontos;
            if (this.vertical) {
                const top = (index / (total - 1)) * (this.spacingVertical * total/this.spacingFactor) + this.marginVertical; // 10% margin top/bottom
                return {
                    position: 'absolute',
                    top: `${top}%`,
                    left: '20%',
                    transform: 'translateX(-50%)'
                };
            } else {
                const left = (index / (total - 1)) * (this.spacingHorizontal * total/this.spacingFactor) + this.marginHorizontal; // 10% margin left/right
                return {
                    position: 'absolute', 
                    left: `${left}%`,
                    top: '50%',
                    transform: 'translateY(-50%)'
                };
            }
        },
        getSegmentoStyle(index, percorrido = false) {
            const total = this.totalPontos;
            const baseStyle = {};
            
            if (this.vertical) {
                const startTop = (index / (total - 1)) * (this.spacingVertical * total/this.spacingFactor) + this.marginVertical;
                const endTop = ((index + 1) / (total - 1)) * (this.spacingVertical * total/this.spacingFactor) + this.marginVertical;
                const height = endTop - startTop;
                
                baseStyle.top = `${startTop}%`; 
                baseStyle.left = '20%';
                baseStyle.height = `${height}%`;
                baseStyle.width = '4px';
                baseStyle.transform = 'translateX(-50%)';
            } else {
                const startLeft = (index / (total - 1)) * (this.spacingHorizontal * total/this.spacingFactor) + this.marginHorizontal;
                const endLeft = ((index + 1) / (total - 1)) * (this.spacingHorizontal * total/this.spacingFactor) + this.marginHorizontal;
                const width = endLeft - startLeft;
                
                baseStyle.left = `${startLeft}%`;
                baseStyle.top = '50%';
                baseStyle.width = `${width}%`;
                baseStyle.height = '4px';
                baseStyle.transform = 'translateY(-50%)';
            }
            
            if (percorrido) {
                baseStyle.backgroundColor = this.primaryColor;
                baseStyle.boxShadow = `0 0 8px ${this.primaryColor}40`;
            }
            
            return baseStyle;
        },
        getVeiculoStyle(veiculo) {
            // Offset da ponta da gota até o centro do ponto/segmento (em px)
            const tipOffsetXpx = 8;  // ajuste horizontal fino
            const tipOffsetYpx = -8;  // ajuste vertical fino

            const total = this.totalPontos;

            let left, top;

            const setPositionAtIndex = (paradaIndex) => {
                if (paradaIndex < 0 || paradaIndex >= total) return false;
                if (this.vertical) {
                    top = (paradaIndex / (total - 1)) * (this.spacingVertical * total/this.spacingFactor) + this.marginVertical;
                    left = 20;
                } else {
                    left = (paradaIndex / (total - 1)) * (this.spacingHorizontal * total/this.spacingFactor) + this.marginHorizontal;
                    top = 50;
                }
                return true;
            };

            const setMidpointBetweenIndices = (paradaIndex) => {
                if (paradaIndex < 0 || paradaIndex >= total - 1) return false;
                const spacing = this.vertical ? this.spacingVertical * total/this.spacingFactor : this.spacingHorizontal * total/this.spacingFactor;
                const margin = this.vertical ? this.marginVertical : this.marginHorizontal;
                const posAtual = (paradaIndex / (total - 1)) * spacing + margin;
                const posProx = ((paradaIndex + 1) / (total - 1)) * spacing + margin;
                const posMeio = posAtual + (posProx - posAtual) * 0.5;

                if (this.vertical) {
                    top = posMeio;
                    left = 20;
                } else {
                    left = posMeio;
                    top = 50;
                }
                return true;
            };

            const findParadaLayoutIndex = (idCerca) => {
                const idx = this.paradas.findIndex(p => Number(p.id_cerca) === Number(idCerca));
                return idx >= 0 ? idx + 1 : -1;
            };

            const findParadaLayoutIndexByOrdem = (ordem) => {
                if (ordem == null) return -1;
                const idx = this.paradas.findIndex(p => Number(p.ordem_parada) === Number(ordem));
                return idx >= 0 ? idx + 1 : -1;
            };

            if (veiculo.id_cerca) {
                if (this.pontoInicial && Number(veiculo.id_cerca) === Number(this.pontoInicial.id_cerca)) {
                    setPositionAtIndex(0);
                } else if (this.pontoFinal && Number(veiculo.id_cerca) === Number(this.pontoFinal.id_cerca)) {
                    setPositionAtIndex(total - 1);
                } else {
                    const paradaIndex = findParadaLayoutIndex(veiculo.id_cerca);
                    if (paradaIndex >= 0) {
                        setPositionAtIndex(paradaIndex);
                    }
                }
            } else if (veiculo.id_cerca_ultima_parada) {
                const paradaIndex = findParadaLayoutIndex(veiculo.id_cerca_ultima_parada);
                if (paradaIndex >= 0) {
                    setMidpointBetweenIndices(paradaIndex);
                }
            } else if (veiculo.ordem_cerca_proxima_parada != null) {
                const ordemProx = Number(veiculo.ordem_cerca_proxima_parada);
                if (ordemProx === 1) {
                    setMidpointBetweenIndices(0);
                } else {
                    const paradaIndex = findParadaLayoutIndexByOrdem(ordemProx - 1);
                    if (paradaIndex >= 0) {
                        setMidpointBetweenIndices(paradaIndex);
                    }
                }
            } else if (veiculo.ordem_parada_efetiva != null) {
                const paradaIndex = findParadaLayoutIndexByOrdem(veiculo.ordem_parada_efetiva);
                if (paradaIndex >= 0) {
                    setMidpointBetweenIndices(paradaIndex);
                }
            }

            // Fallback para início se não encontrou posição
            if (left === undefined || top === undefined) {
                if (this.vertical) {
                    top = 1;
                    left = 20;
                } else {
                    left = 10;
                    top = 50;
                }
            }

            // Aplica o deslocamento para alinhar a ponta da gota
            return {
                left: `${left}%`,
                top: `${top}%`,
                transform: this.vertical
                    ? `translate(calc(-150% + ${tipOffsetXpx}px), ${tipOffsetYpx}px)`
                    : `translate(calc(-50% + ${tipOffsetXpx}px), calc(-100% + ${tipOffsetYpx}px))`
            };
        },
        getVeiculoGotaStyle(veiculo) {
          let bgColor;
          if (veiculo.gps_offline == 1) {
            bgColor = '#4a4a4a';
          }else if (veiculo.sentido === 1) {
            bgColor = '#FF5722'; /* Volta: laranja */
          } else {
            bgColor = '#008000'; /* Ida: verde */
          }
          let style = { backgroundColor: bgColor };

          if (this.vertical) {
            style.transform = 'rotate(-135deg)';
          } else {
            style.transform = 'rotate(-45deg)';
          }

          return style;
        },
        getVeiculoGotaIconStyle() {
          let style = {};
          if (this.vertical) {
            style.transform = 'rotate(135deg)';
          } else {
            style.transform = 'rotate(45deg)';
          }
          return style;
        },
        isParadaVisitada(index) {
            return index < this.paradaAtualIndex;
        },
        isParadaAtiva(parada) {
            // Uma parada está ativa se algum veículo estiver exatamente nela
            if (this.veiculosSelecionados.length === 0) {
                return false;
            }

            if (!parada) {
                return false;
            }

            // Ponto final: nunca mostrar círculo pintado/ativo
            if (this.pontoFinal && parada.id_cerca === this.pontoFinal.id_cerca) {
                return false;
            }

            return this.veiculosSelecionados.some(v => 
                v.id_cerca !== null && 
                v.id_cerca !== undefined && 
                v.id_cerca !== 0 && 
                v.id_cerca === parada.id_cerca
            );
        },
        isParadaMaisProxima(parada) {
            if (!parada || !this.pontoMaisProximo) {
                return false;
            }

            return parada.id_cerca === this.pontoMaisProximo.id_cerca;
        },
        getParadaMaisProximaIconStyle(parada) {
            if (!parada) {
                return {};
            }

            const index = this.paradasFiltered.findIndex(p => p.id_cerca === parada.id_cerca);
            const isVisitada = this.isParadaVisitada(index);
            const isAtiva = this.isParadaAtiva(parada);
            const isInicialOuFinal = parada.id_cerca === this.pontoInicial?.id_cerca || parada.id_cerca === this.pontoFinal?.id_cerca;
            const fundoPrimario = isAtiva || isVisitada || isInicialOuFinal;

            return {
                color: fundoPrimario ? '#ffffff' : this.primaryColor,
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
            };
        },
        getParadaStyle(parada) {
            if (!parada) {
                return {};
            }

            // Ponto final: sempre apenas contorno, nunca círculo pintado
            if (this.pontoFinal && parada.id_cerca === this.pontoFinal.id_cerca) {
                return {
                    backgroundColor: 'white',
                    border: `3px solid ${this.primaryColor}`
                };
            }

            const index = this.paradasFiltered.findIndex(p => p.id_cerca === parada.id_cerca);

            const isVisitada = this.isParadaVisitada(index);
            const isAtiva = this.isParadaAtiva(parada);
            
            const style = {};
            
            if (isAtiva) {
                style.backgroundColor = this.primaryColor;
                style.transform = 'scale(1.3)';
                style.boxShadow = `0 0 0 4px ${this.primaryColor}40`;
            } else if (isVisitada) {
                style.backgroundColor = this.primaryColor;
            } else {
              // Para paradas não visitadas, incluindo ponto inicial e final
                style.backgroundColor = 'white';
                style.border = `3px solid ${this.primaryColor}`;
            }
            
            return style;
        },
        getLabelClass(ponto) {
          if (!ponto || ponto?.nome_cerca.length < 16 || this.vertical) {
            return "label-texto";
          }

          return "label-texto animated-label";
        },
        getPassagemVeiculo(parada) {
          // Returns the timestamp of when a vehicle passed through this stop
          if (!parada || !parada.id_cerca) return null;
          
          // Find if any vehicle is currently at this stop
          const veiculoNaParada = this.veiculosSelecionados.find(v => 
            v.id_cerca === parada.id_cerca
          );
          
          if (veiculoNaParada && veiculoNaParada.dt_gps) {
            return veiculoNaParada.dt_gps;
          }
          
          // Check if this is the last stop any vehicle passed
          const veiculoPassou = this.veiculosSelecionados.find(v => 
            v.id_cerca_ultima_parada === parada.id_cerca && v.dt_ultima_parada
          );
          
          if (veiculoPassou && veiculoPassou.dt_ultima_parada) {
            return veiculoPassou.dt_ultima_parada;
          }
          
          return null;
        },
        onParadaClick(parada) {
          // Emit event to parent component with the selected stop
          this.$emit('parada-selected', parada);
        },
        onParadaFocus(parada) {
          // Trigger the click action when focused
          if (!parada) return;
          this.onParadaClick(parada);
        },
        onVeiculoFocus(veiculo) {
          // Trigger the selection action when focused
          this.$emit('veiculo-selected', veiculo);
        },
        onVeiculoEnter(veiculo) {
          // When Enter is pressed on a vehicle, emit an event (can be handled by parent)
          this.$emit('veiculo-selected', veiculo);
        },
        centralizarScrollNoPonto(ponto) {
            if (!ponto || !ponto.id_cerca) return;
            
            this.$nextTick(() => {
                const pontoElement = this.$el.querySelector(`[data-ponto-id="${ponto.id_cerca}"]`);
                if (pontoElement) {
                    const scrollContainer = this.$el;
                    if (scrollContainer) {
                        const containerHeight = scrollContainer.clientHeight;
                        const scrollTop = pontoElement.offsetTop;
                        const elementoHeight = pontoElement.offsetHeight;
                        
                        // Calcula a posição para centralizar o elemento na tela
                        const scrollPosition = scrollTop - (containerHeight / 2) + (elementoHeight / 2);
                        
                        // Aplica o scroll com animação suave
                        scrollContainer.scrollTo({
                            top: Math.max(0, scrollPosition),
                            behavior: 'smooth'
                        });
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.sinotico-titulo {
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
}

.sinotico-container {
  position: relative;
  width: 100%;
  height: 250px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow-y: hidden;
  overflow-x: auto;
}

.sinotico-container.vertical {
  width: 100%;
  height: 50vh;
  min-height: 400px;
  padding: 20px 40px 20px 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Linha de progresso */
.linha-progresso {
  position: relative;
  width: 100%;
  height: 100%;
}

.vertical .linha-progresso {
  height: 100vh;
}

/* Pontos */
.ponto {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ponto-circulo {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Estilo base para ponto selecionado (cor e pulsação vêm das classes sentido) */
.ponto-circulo.selecionada {
  transform: scale(1.2);
  position: relative;
}

/* Sentido ida: pulsar verde */
.ponto-circulo.selecionada.selecionada-ida {
  border: 3px solid #008000;
  background: linear-gradient(135deg, #008000 0%, #00a300 100%);
  box-shadow: 0 0 0 3px rgba(0, 128, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: pulsar-verde 2s infinite;
}

.ponto-circulo.selecionada.selecionada-ida::before {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border: 2px solid rgba(0, 128, 0, 0.4);
  border-radius: 50%;
  animation: ripple-selecionado-verde 2s infinite;
}

/* Sentido volta: pulsar laranja */
.ponto-circulo.selecionada.selecionada-volta {
  border: 3px solid #FF5722;
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: pulsar-laranja 2s infinite;
}

.ponto-circulo.selecionada.selecionada-volta::before {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border: 2px solid rgba(255, 87, 34, 0.4);
  border-radius: 50%;
  animation: ripple-selecionado-laranja 2s infinite;
}

/* Estilos básicos dos círculos - cores aplicadas dinamicamente via :style */

/* Labels dos pontos */
.ponto-label {
  position: absolute;
  top: 40px;
  left: -28px;
  transform: translateX(-50%) rotate(-45deg);
  text-align: end;
  font-size: 12px;
  min-width: 80px;
  max-width: 120px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@keyframes scroll-text {
  0% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(-50%);  /* desliza para fora */
  }
  60% {
    transform: translateX(-50%);  /* pausa no final */
  }
  100% {
    transform: translateX(0);      /* volta ao início */
  }
}

@keyframes pulsar-verde {
  0% {
    box-shadow: 0 0 0 3px rgba(0, 128, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.2);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(0, 128, 0, 0.2), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.3);
  }
  100% {
    box-shadow: 0 0 0 3px rgba(0, 128, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.2);
  }
}

@keyframes pulsar-laranja {
  0% {
    box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.2);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(255, 87, 34, 0.2), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.3);
  }
  100% {
    box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.2);
  }
}

@keyframes ripple-selecionado-verde {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes ripple-selecionado-laranja {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes fade-in-passageiro {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.vertical .ponto-label {
  position: static;         /* libera do posicionamento fixo */
  transform: translate(50%, -80%);          /* remove rotação */
  text-align: left;         /* alinhamento natural */
  white-space: normal;      /* deixa o texto quebrar em múltiplas linhas */
  overflow: visible;        /* permite expandir */
  text-overflow: unset;     /* remove os "..." */
  max-width: none;          /* libera limite de largura */
}

.vertical .label-texto {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-left: 10px;
}

.label-texto {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  padding-right: 10px;
}

.animated-label {
  animation: scroll-text 6s linear infinite;
}

.label-hora {
  display: block;
  position: absolute;
  color: #666;
  font-size: 10px;
  left: 10px;
}

/* Segmentos da linha */
.segmento-linha {
  position: absolute;
  background: #ddd;
  z-index: 1;
  transition: all 0.3s ease;
}

/* Segmentos percorridos - cores aplicadas dinamicamente */

/* Veículo */
.veiculo {
  position: absolute;
  z-index: 4;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.veiculo-icone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.veiculo-gota {
  width: 32px;
  height: 32px;
  border-radius: 50% 50% 50% 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  /* Background color definida dinamicamente no template */
}

.veiculo-gota i {
  font-size: 16px;
  color: #fff;
}

.veiculo-info {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  text-align: center;
  min-width: 80px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  display: none;
}

.vertical .veiculo-info {
  transform: translate(-90%, calc(-100% - 7px));
  min-width: 50px;
  text-align: left;
}

.veiculo-nome {
  display: block;
  font-weight: 600;
  color: #333;
}

.veiculo-status {
  display: block;
  color: #666;
  font-size: 9px;
}
.vertical {
  top: auto;
  left: auto;
}

/* Responsividade */
@media (max-width: 768px) {
  .sinotico-container {
    height: 140px;
    padding: 35px 15px 15px 15px;
  }
  
  .veiculo-icone {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
  
  .ponto-label {
    font-size: 11px;
    min-width: 70px;
  }
  
  .veiculo-info {
    font-size: 9px;
    min-width: 70px;
  }
  
  /* Ajustes para ponto selecionado em telas médias */
  .ponto-circulo.selecionada {
    transform: scale(1.15);
  }
  
  .passageiro-icone {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .sinotico-container {
    height: 120px;
    padding: 30px 10px 10px 10px;
  }

  
  .veiculo-icone {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .ponto-label {
    font-size: 10px;
    min-width: 60px;
  }
  
  .veiculo-info {
    font-size: 8px;
    min-width: 60px;
  }
  
  /* Ajustes para ponto selecionado em telas pequenas */
  .ponto-circulo.selecionada {
    transform: scale(1.1);
  }
  
  .passageiro-icone {
    font-size: 9px;
  }
}

/* Hover effects */
.ponto-circulo:hover {
  transform: scale(1.3);
  cursor: pointer;
}

.veiculo-gota:hover {
  transform: rotate(-45deg) scale(1.1);
  cursor: pointer;
}

/* Estados especiais */
.sinotico-container.loading {
  opacity: 0.7;
}

.sinotico-container.loading .veiculo-gota {
  animation: pulse 0.8s infinite;
}
</style>